import { init } from './init';
import { getValue, getNumberValue, getTargetCubeAllData, depGet, hasKey, getLogicValue, has, allCube } from './get';
import { setValue } from './set';
import { add } from './add';
import { updateAllKeysByCubeId, updateAllCube } from './update';
import { clear, del, delGroup } from './delete';

export {
    init,
    getValue,
    getNumberValue,
    getTargetCubeAllData,
    depGet,
    setValue,
    updateAllKeysByCubeId,
    hasKey,
    getLogicValue,
    clear,
    add,
    has,
    del,
    delGroup,
    allCube,
    updateAllCube
};

export default {
    init,
    getValue,
    getNumberValue,
    getTargetCubeAllData,
    depGet,
    setValue,
    updateAllKeysByCubeId,
    hasKey,
    getLogicValue,
    clear,
    add,
    has,
    del,
    delGroup,
    allCube,
    updateAllCube
}
